// The client-side counterpart of `$('#flash').replaceWith(<shared/flash>)` in the .js.erb error
// templates, for callers on fetch, which does not run a server-rendered script. Replaces whatever
// the flash showed, as those templates do.
export const showAlert = (message) => {
  const flash = document.getElementById("flash");
  if (!flash) return;

  const alert = document.createElement("div");
  alert.className = "alert alert-danger";
  alert.dataset.clientAlert = "";
  alert.textContent = message;
  flash.replaceChildren(alert);
};

// Takes back what showAlert put up, e.g. once a retried save goes through, and leaves the
// server-rendered flash alone.
export const clearAlerts = () => {
  document.querySelectorAll("#flash [data-client-alert]").forEach((alert) => alert.remove());
};
